var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("circle",{"cx":"20","cy":"20","r":"20","fill":"#EBECF7","key":1}),React.createElement("path",{"d":"M28 15.5c-.6.3-1.2.5-1.9.6.7-.4 1.2-1 1.5-1.9-.7.4-1.4.7-2.1.8a3.3 3.3 0 00-5.6 3 9.3 9.3 0 01-6.8-3.4 3.3 3.3 0 001 4.4c-.5 0-1-.2-1.5-.4 0 1.6 1.2 3 2.7 3.2a3.3 3.3 0 01-1.5.1 3.3 3.3 0 003 2.3 6.6 6.6 0 01-4.8 1.3 9.3 9.3 0 0014.4-8.3c.6-.4 1.2-1 1.6-1.7z","fill":"#6573FF","key":2})]);
}

Twitter.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
